import React from 'react';

import {
  SearchResult,
} from '../../../components';

import GroupedContentFull from '../GroupedContent/Full';
import DownloadTeaser from './teaser';
import DownloadTeaserLarge from './teaser_large';

const Download = ({ entity, className, viewMode, ...props }) => {
  switch (viewMode) {
    case 'search_result':
      return (<SearchResult entity={entity} {...props} />);
    case 'teaser':
      return (<DownloadTeaser entity={entity} {...props} />);
    case 'teaser_large':
      return (<DownloadTeaserLarge entity={entity} {...props} />);
    case 'full':
    default:
      return (<GroupedContentFull entity={entity} {...props} />);
  }
};

export default Download;
